import React from 'react';
import { FileDrop } from 'react-file-drop';
import MaterialIcon from 'material-icons-react';
import { FlexCol } from './Styled';

const DropZone = (props) => {
  if (props.file) return null;

  const handleDropChange = (files, e) => {
    e.preventDefault();
    e.stopPropagation();

    props.onChange(files);
  };

  return (
    <div
      style={{
        height: 150,
        width: '100%'
      }}
    >
      <FileDrop className="drop-zone" onDrop={handleDropChange}>
        <FlexCol>
          <MaterialIcon
            size={48}
            icon="cloud_upload"
            color={'rgba(0, 118, 190, 0.12)'}
          />
          <span
            style={{
              fontWeight: 400,
              color: 'rgb(55, 85, 103)',
              textTransform: 'uppercase'
            }}
          >
            drag & drop file here or...
          </span>
        </FlexCol>
      </FileDrop>
    </div>
  );
};

export default DropZone;
